import { CurrencyRecord, SupportedCurrency } from '../domain/currency';
import { TransportOrder } from '../domain/transportOrder';

export const parsePrice = (value: string | undefined): number => Number((value ?? '0').replace(',', '.'));

export const getAmountInPLN = (currencyRecord: CurrencyRecord, value: number, currency: SupportedCurrency) => {
    if (currency === 'PLN') {
        return value;
    }

    const currencyRate = currencyRecord[currency];

    return value * currencyRate.exchangeRate;
};

export const prepareFreight = (freight: TransportOrder['freight'], currencyRecord: CurrencyRecord): {
    clientValue: number,
    contractorValue: number,
    currency: TransportOrder['freight']['currency'],
    computed: boolean,
} => {
    const { clientValue, clientCurrency, value, currency } = freight;

    if (currency === clientCurrency) {
        return {
            clientValue: parsePrice(clientValue),
            contractorValue: parsePrice(value),
            currency,
            computed: false,
        };
    }

    const contractorValueInClientCurrency = parsePrice(value) / currencyRecord[clientCurrency].exchangeRate;

    return {
        clientValue: parsePrice(clientValue),
        contractorValue: contractorValueInClientCurrency,
        currency: clientCurrency,
        computed: true,
    };
};

export const formattedEurToPln = (currencyRecord: CurrencyRecord) => `${(1).toLocaleString('pl-PL', {
        style: 'currency',
        currency: 'EUR',
    })} = ${currencyRecord.EUR.exchangeRate.toLocaleString('pl-PL', {
            style: 'currency',
            currency: 'PLN',
        })}`